// metanoia.tw PDP links for NOKE counter rows.
//
// Shared by the POS (複製商品連結 — staff paste the link into LINE) and the
// 庫存 tab (品名 links to the live product page so staff can check photos,
// measurements and 官網 price while standing at the counter).
//
// One host for both brands on purpose: MdoC products render in-app under
// metanoia.tw (App.tsx routes /products/:handle → /shop/:handle for every
// vendor), so there is no MdoC/Metanoia branching to do here.

export const STOREFRONT_BASE = 'https://metanoia.tw';

export const pdpUrl = (handle: string): string =>
  `${STOREFRONT_BASE}/products/${encodeURIComponent(handle)}`;
